import { Injectable } from '@angular/core';
import { ApiInterface } from '../api-interface';
import { ApiService } from '../api.service';
import { Observable } from 'rxjs';
import { TipoDespesaResponseDTO } from '../../models/tipo-despesa.model';

@Injectable({
    providedIn: 'root',
})
export class TipoDespesaService implements ApiInterface {
    constructor(private apiService: ApiService) { }

    get<T>(url: string, data?: any): Observable<T> {
        const queryParams = this.apiService.buildQueryParams(data);
        const patch = queryParams ? `${url}?${queryParams}` : url;
        return this.apiService.read<TipoDespesaResponseDTO>(patch);
    }
    post<T>(url: string, data: any): Observable<T> {
        return this.apiService.create<T>(url, data);
    }
    put<T>(url: string, data: any): Observable<any> {
        throw new Error('Method not implemented.');
    }
    delete<T>(url: string): Observable<any> {
        throw new Error('Method not implemented.');
    }

}
